.wrapper {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.mentorMain {
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 0;
  padding-top: var(--space-6);
}

.mentorIntro {
  max-width: var(--page-max-width);
  margin: var(--space-3) auto var(--space-6);
  padding-inline: var(--page-padding-x);

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.mentorIntro h2 {
  margin: 0;
  letter-spacing: 0.02em;
  color: var(--color-text-dark);
  font-family: var(--font-family-heading);
  font-size: var(--font-size-3xl);
}

.mentorIntro p {
  margin: var(--space-3) 0 0;
  color: var(--color-text-muted);
  font-size: var(--font-size-md);
  font-family: var(--font-family-base);
}

.mentorContentWrapper {
  flex: 1;
  display: flex;
  min-height: 0;
  width: 100%;
  max-width: calc(100dvh * 1.75);
  margin-inline: auto;
}

.mentorBrowserWrapper {
  max-width: var(--page-max-width);
  margin: var(--space-8) auto;
  padding-inline: var(--page-padding-x);
}
